export default "__VITE_ASSET__854fc0ee__"